import ServiceItemMeasureUnit from "./enums/ServiceItemMeasureUnit";
import ItemGroupModel from "./ItemGroupModel";
import ItemManufacturerModel from "./ItemManufacturerModel";
import ItemMeasureUnitModel from "./ItemMeasureUnitModel";

export default class ItemModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.date = data.date ?? new Date(1970, 0, 1);
			this.externalName = data.externalName;
			this.partNumber = data.partNumber;
			this.internalDescription = data.internalDescription;

			if (data.measureUnit) {
				this.measureUnit = data.measureUnit as ServiceItemMeasureUnit;
			}

			if (data.manufacturer) {
				this.manufacturer = new ItemManufacturerModel(data.manufacturer);
			}
			
			if (data.group) {
				this.group = new ItemGroupModel(data.group);
			}
		}
	}

	id = 0;
	date = new Date(1970, 0, 1);
	externalName = '';
	internalDescription: string | null = null;
	partNumber = '';
	manufacturer: ItemManufacturerModel | null = null;
	group: ItemGroupModel | null = null;
	measureUnit: ServiceItemMeasureUnit = ServiceItemMeasureUnit.Piece;
}